import { MaterialStatus } from './material-status';

export interface IMaterialCallout {
    standardMaterialId: string | undefined;
    id: string;
    description: string;
    vendorUrl: string;
    pricePerUnit: number;
    quantity: number;
    procurementStatus: MaterialStatus;
    expectedDeliveryDate: number;
}


export class MaterialCallout implements IMaterialCallout {
    public standardMaterialId: string | undefined = undefined;
    public id: string = '';
    public description: string = '';
    public vendorUrl: string = '';
    public pricePerUnit: number = 0;
    public quantity: number = 0;
    public procurementStatus: MaterialStatus = MaterialStatus.Unacquired;
    public expectedDeliveryDate: number = 0;
}


